import { createSlice } from "@reduxjs/toolkit";

import { requestSize } from "../requests/thunks/requestSize";
import { requestSizeUpdate } from "../requests/thunks/requestSizeUpdate";
import { requestDesign_Aggregated } from "../requests/thunks/requestDesign_Aggregated";
import { requestDesignUpdate } from "../requests/thunks/requestDesignUpdate";
import { requestSummary_Aggregated } from "../requests/thunks/requestSummary_Aggregated";

const initialState = {
  SquareMeterStomme: null,
  // Partout article numbers
  ErpArticleNumbers: [],
  // Article information for all articles in partout
  Articles: [],
  // Filtered documents that only contains unique documents based
  UniqueDocuments: [],
  // Pricehelper summary: Price and delivery information for partout bundle
  Summary: {},
  /*
  Price information (below) from CGE used at step 3 and 4,
  equals to the summary price info from pricehelper
  (the same campaign price logic is applied at backend)
  */
  Price: null,
  OrdinaryPrice: null,
  // Used to display cost of option PanelIsolation in step 4
  IsolationCost: null,
  // Used to calculate and display cost for each available frame option in step 4
  FrameArticles: [],
  UterumHeights: {},
  // Will include art.no, width, depth for roof,
  Roof: {},
  // NOTE: ImagesLeft and ImagesRight are only used in SummaryView (step 5)
  // For step 3 and 4, we use ImagesSlice instead
  // (Objects will include 'Images' arr and 'CurrentAngle' str)
  ImagesLeft: {},
  ImagesRight: {},
  Discounts: []
};

const handleCgeResult = (state, action) => {
  const { cgeObj } = action.payload;

  const {
    SquareMeterStomme,
    ErpArticleNumbers,
    Price,
    OrdinaryPrice,
    IsolationCost,
    UterumHeights,
    Roof,
    ImagesLeft,
    ImagesRight,
    Discounts,
    ProductDiscount,
  } = cgeObj;

  // Is updated for all steps (3, 4, 5)
  state.SquareMeterStomme = SquareMeterStomme;
  state.ErpArticleNumbers = ErpArticleNumbers;
  state.Price = Price;
  state.OrdinaryPrice = OrdinaryPrice;
  state.Discounts = Discounts;
  state.ProductDiscount = ProductDiscount;

  // Can be undefined, set default value null
  state.IsolationCost = IsolationCost || null;

  // Will be undefinied in step 3 and 4, use default value {}
  state.UterumHeights = UterumHeights || {};
  state.Roof = Roof || {};
  state.ImagesLeft = ImagesLeft || {};
  state.ImagesRight = ImagesRight || {};
};

const handleFramePricesResult = (state, action) => {
  /*
  Response array is not only containing prices,
  it also has additional article info such as Sku (erpId)
  */
  const { FrameArticles } = action.payload;

  state.FrameArticles = FrameArticles;
};

const handlePricehelperResult = (state, action) => {
  const { pricehelperObj } = action.payload;
  const { articles, summary, errors } = pricehelperObj;

  !articles && console.error("Missing articles in pricehelper response data");

  errors && errors.forEach((error) => console.error(error.Message));

  const uniqueDocuments = [];

  articles &&
    articles.map((article) =>
      article.Documents.forEach(
        (document) =>
          !uniqueDocuments.some((item) => item.Url === document.Url) &&
          uniqueDocuments.push(document)
      )
    );

  const articlesNotaAvilableForPurchace = articles.filter(
    (article) => article.IsAvailableForPurchase === false
  );

  // Note:
  // Upper camelcase is consistently used in
  // application store for data from backend
  state.UniqueDocuments = uniqueDocuments;
  state.Articles = articles || [];
  state.Summary = summary || {};
  state.Errors = errors || {};
  state.ArticlesNotaAvilableForPurchace = articlesNotaAvilableForPurchace;
};

const ResultSlice = createSlice({
  name: "Result",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(requestSize.fulfilled, (state, action) => {
        handleCgeResult(state, action);
      })
      .addCase(requestSizeUpdate.fulfilled, (state, action) => {
        handleCgeResult(state, action);
      })
      .addCase(requestDesignUpdate.fulfilled, (state, action) => {
        handleCgeResult(state, action);
      })
      .addCase(requestDesign_Aggregated.fulfilled, (state, action) => {
        handleCgeResult(state, action);
        handleFramePricesResult(state, action);
      })
      .addCase(requestSummary_Aggregated.fulfilled, (state, action) => {
        handleCgeResult(state, action);
        handlePricehelperResult(state, action);
      });
  },
});

export default ResultSlice.reducer;
